<template>
    <div>
      <owner-list></owner-list>
    </div>
  </template>
  
  <script>
  
  export default {
  }
  </script>
  
  
  